/* Import Module */
import { getSchedules } from "../axios/schedule/scheduleAxios";
import { getGroupingDepartmentUserByMulti } from "../axios/user/GroupingDepartmentUserByMultiPulldownAxios";
import { nextTick } from "vue";
import { isShow } from "../variables";

/* Define Const */
/* ページリロード 時間定義 */
// msでの表記
export const delay = 40000; // 40sec
// const delay = 10000000000; // 10min

let intervalId: number = 0;

/* Define Script */
const changeScheduleLists = async () => {
  // 担当者変更ダイアログ用ユーザ情報 取得
  getGroupingDepartmentUserByMulti();
  // スケジュール情報 取得
  await getSchedules();
  isShow.loading = true;
  await nextTick(() => (isShow.render = false));
  isShow.render = true;
  await new Promise((resolve) => setTimeout(resolve, 1000));
  isShow.loading = false;
};

export const automaticPageReload = () => {
    intervalId = Number(setInterval(changeScheduleLists, delay));
};

export const automaticPageReloadStop = () => {
    clearInterval(intervalId);
    intervalId = 0;
};
